<template>
  <div :class="['netease', 'section']">
    <!-- <n-loading v-if="loading" :cover="cover" @openVideo="play"/> -->
    <div :class="['gif-ctn', {'x': isX}]" @click="play" v-if="loading">
    </div>
    <div :class="['m-fullvideo', {'end': playing}, {'x': isX}]" @click="play">
      <video
        v-if="isShowVideo"
        ref="video"
        :class="[{'playing': playing}, {hide: hide}]"
        :poster="startSource"
        x-webkit-airplay="allow"
        x5-video-player-type="h5"
        x5-playsinline
        webkit-playsinline playsinline>
        <source :src="videoSource" type="video/mp4" />
      </video>
      <div :class="['cover-start', {'x': isX}]" v-if="!loading && !playing"></div>
      <div class="gobuy" @click="gobuy"></div>
    </div>
  </div>
</template>

<script>
// import NLoading from '@/components/n-loading'

// x:
// https://ar-scene-source.nosdn.127.net/5b5c80d2-261b-44c2-a6ae-04e42700df6b.mp4
// 6:
// https://ar-scene-source.nosdn.127.net/54ef5e22-bf75-4fc4-a180-29d0a6acecc5.mp4

const iphoneX = "https://ar-scene-source.nosdn.127.net/5b5c80d2-261b-44c2-a6ae-04e42700df6b.mp4"
const iphone6 = "https://ar-scene-source.nosdn.127.net/54ef5e22-bf75-4fc4-a180-29d0a6acecc5.mp4"
const iphoneXStart = "https://ar-scene-source.nosdn.127.net/494b69af-c9e9-43e6-ba77-a9076b37016c.gif"
const iphone6Start = "https://ar-scene-source.nosdn.127.net/29641df3-af53-46a8-9907-40de7ff9a3d5.gif"
export default {
  // components: {
  //   NLoading
  // },
  data () {
    return {
      videoSource: this.isX ? iphoneX : iphone6,//require('../assets/images/overview/start_old.mp4'),//
      startSource: this.isX ? iphoneXStart: iphone6Start,
      hide: false, // 视频是否已播放完
      playing: false, // 视频是否正在播放
      loading: true, // loading页是否存在
      // cover: false, // 视频封页是否显示
      // logo: false,
      time: 0,
      timer: null,
      isShowVideo: true

    }
  },
  watch: {
    hide(newValue) {
      if(newValue == true){
        window.gtag && window.gtag("event", "finish_play")
      }
    }
  },
  mounted() {
    this.videoNode = this.$refs.video
    this.videoNode.controls = false
    this.videoNode.addEventListener('canplay', () => {
        // this.cover = true
    }, false)
    this.videoNode.addEventListener('ended', () => {
      this.hide = true
    }, false)
    this.videoNode.addEventListener('timeupdate', () => {
      // 开始播放后执行
      if (this.videoNode.currentTime > 0.1 && !this.playing) {
        window.gtag && window.gtag("event", "start_play")
        this.playing = true
      }

      // 以下代码兼容Android X5在浏览器行为
      if (this.videoNode.currentTime > 56.9) {
        this.isShowVideo = false
        this.hide = true
      }
    }, false)

    // // 视频最长3s加载时间
    // setTimeout(() => {
    //   !this.cover && (this.cover = true)
    // }, 3000);
    this.timer = setInterval(() => {
      this.time++
    }, 1000)
  },
  methods: {
    play () {
      if (!this.hide && this.time > 5) {
        this.loading = false
        this.videoNode && this.videoNode.play()
        this.timer && window.clearInterval(this.timer)
      }
    },
    gobuy() {
      if (this.hide) {
        window.gtag && window.gtag("event", "to_zhongchou")
        window.location.href = "https://z.m.jd.com/project/details/103073.html"
      }
    }
  }
}
</script>


<style lang="postcss">
.netease {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #000000;
}

.gif-ctn {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url("https://ar-scene-source.nosdn.127.net/29641df3-af53-46a8-9907-40de7ff9a3d5.gif") center center;
  background-size: cover;

  &.x {
    background: url("https://ar-scene-source.nosdn.127.net/494b69af-c9e9-43e6-ba77-a9076b37016c.gif") center center;
    background-size: cover;
  }
}

.m-fullvideo{
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: url("../assets/images/netease/6-start.jpg") center center;
  background-size: cover;
  &.x {
    background: url("../assets/images/netease/x-start.jpg") center center;
    background-size: cover;
  }
  &.end {
    background: url("../assets/images/netease/6-end.jpg") center center;
    background-size: cover;
  }
  &.end.x {
    background: url("../assets/images/netease/x-end.jpg") center center;
    background-size: cover;
  }

  video{
    width: 100%;
    height: 100%;
    object-fit: cover;
    &.hide {
      opacity: 0;
    }

    &.playing {
      width: 100%;
      height: 100%;
    }
  }

  .cover-start {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: url("../assets/images/netease/6-start.jpg") center center;
    background-size: cover;

    &.x {
      background: url("../assets/images/netease/x-start.jpg") center center;
      background-size: cover;
    }
  }

  .gobuy {
    position: absolute;
    top: 10%;
    left: 0;
    bottom: 10%;
    right: 0;
  }
}



</style>

